<template>
  <v-navigation-drawer
    app
    class="parent-list-overflow"
    v-model="localValue"
    fixed
    temporary>
    <div class="list-overflow">
      <v-list-item class="pl-2">
        <v-avatar color="blue" size="40" class="mr-2">
          <v-img src="../../assets/default-user1.png"/>
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">
            <strong v-if="user">{{ user.nome }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle>
            Seja bem-vindo(a)
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>
      <v-list dense>
        <v-list-item-group>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/meu-painel"
          >
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Início</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/calendario"
          >
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Calendário</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/agendamento"
          >
            <v-list-item-icon>
              <v-icon>mdi-book-clock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Agendamento</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/tags"
          >
            <v-list-item-icon>
              <v-icon>mdi-format-color-fill</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Tags, planos, contratos</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/cliente"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Clientes</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            active-class="deep-purple--text text--accent-4"
            to="/user"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-tie</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Usuários, funcionário</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>
<script>
import UserService from '@/api/user-service';

export default {
  data() {
    return {
      mini: true,
      navigationOpened: true,
      group: null,
      user: null,
    };
  },
  mounted() {
    this.consultaDados();
  },
  methods: {
    consultaDados() {
      UserService.getContext().then((userData) => {
        this.user = userData.data;
      });
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  props: ['value'],
};
</script>
